'use strict';

import React from 'react';
import { useState, useRef, useEffect, useContext } from 'react';

import { Button, Form, Row, Col, Modal, ButtonGroup } from 'react-bootstrap';

import { Formik } from 'formik';
import * as yup from 'yup';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'
import deLocale from '@fullcalendar/core/locales/de';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import Alert from '../helper/Alert';
import Loader from '../helper/Loader';
import Separator from '../helper/Separator';
import AppContext from '../AppContext';
import ModalCloseButton from '../helper/Modal/ModalCloseButton';

import { formatTime, getHolidays } from '../helper/DateTimeFormater';


import { email, salutation, firstName, lastName, organisationName, phoneNo } from '../helper/Schema';
import { useMemo } from 'react';

import MandatoryFieldNotice from '../helper/MandatoryFieldNotice';

const schema = yup.object().shape({
    SalutationID: salutation,
    FirstName: firstName,
    LastName: lastName,
    Email: email,
    PhoneNo : phoneNo,
    OrganisationName: organisationName,
});


const CalendarHeader = ({ calendarRef, viewType }) => {
    const [title, settitle] = useState(new Date().toLocaleString('de-DE', { month: 'short', year: 'numeric' }));

    const nextHandle = () => {
        calendarRef.current.getApi().next();
        settitle(calendarRef.current.getApi().currentDataManager.data.viewTitle);
    }
    const prevHandle = () => {
        calendarRef.current.getApi().prev();
        settitle(calendarRef.current.getApi().currentDataManager.data.viewTitle);
    }
    const todayHandle = () => {
        calendarRef.current.getApi().today();
        settitle(calendarRef.current.getApi().currentDataManager.data.viewTitle);
    }

    const monthViewHandle = () => {
        calendarRef.current.getApi().changeView('dayGridMonth')
    }

    useEffect(() => {
        settitle(calendarRef.current.getApi().currentDataManager.data.viewTitle);
    }, [viewType]);


    return (
        <div className='mb-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", flexWrap: "wrap" }}>
            <div>
                <ButtonGroup>
                    <button className="btn btn-primary" type="button" onClick={() => prevHandle()}><i className="fa fa-arrow-left"></i></button>
                    <span className="mx-2" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "fit-content", fontWeight: "bold" }}>{title}</span>
                    <button className="btn btn-primary" type="button" onClick={() => nextHandle()}><i className="fa fa-arrow-right"></i></button>
                    <button className="btn btn-secondary ms-2" type="button" onClick={() => todayHandle()}>Heute</button>
                    {viewType != "dayGridMonth" && <button className="btn btn-secondary ms-2" type="button" onClick={() => monthViewHandle()}>Monatsansicht</button>}
                </ButtonGroup>

                <a className="btn btn-primary ml-md-2 mt-2 mt-md-0" href="/vorfuehrtermine-kontakt">Kontakt aufnehmen</a>
            </div>
        </div>
    );
}    

function AppointmentCalendar() {
    const { request } = useRequest();

    const calendarRef = useRef();

    const [view, setView] = useState("dayGridMonth");
    const [slots, setSlots] = useState(false);
    const [event, setEvent] = useState(false);
    const [modal, setModal] = useState(false);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [loading, setLoading] = useState(false);
    const [timeslotCache, setTimeslotCache] = useState([]);


    const updateSlots = (event) => {
        setSlots(oldSlots => {
            return oldSlots.filter(i => {
                if (i.extendedProps.AppointmentID == event.extendedProps.AppointmentID && i.extendedProps.TimeStart == event.extendedProps.TimeStart) {
                    return false;
                }

                return true;
            });
        });
    };

    const loadSlots = async () => {
        try {
            const m = month;
            const y = year;
            let result = await request("/Home/GetAppointments", {month, year});
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }
                setLoading(false);
                setSlots([]);
            }
            else {
                let slots = [];
                setLoading(false);
                for (var i = 0; i < json.slots.length; i++) {
                    let appointment = json.slots[i];
                    let t1 = new Date(appointment.Appointment + " " + appointment.TimeStart);
                    let t2 = new Date(appointment.Appointment + " " + appointment.TimeEnd);
                    let totalMinutes = t2.getHours() * 60 - t1.getHours() * 60;
                    totalMinutes += t2.getMinutes() - t1.getMinutes();
                    let count = Math.floor(totalMinutes / appointment.IntervalTime);
                    let startTime = new Date(appointment.Appointment + " " + appointment.TimeStart);
                    let nextTime;
                    for (let i = 0; i < count; i++) {
                        let startTimeStr = formatTime(startTime);
                        let foundSlot = appointment.Bookings.find(i => formatTime(i.TimeStart) == startTimeStr);
 
                        nextTime = new Date(startTime.getTime() + 1000 * 60 * appointment.IntervalTime);
                        if (foundSlot) {
                            startTime = nextTime;
                            continue;
                        }
                        slots.push({
                            id: appointment.AppointmentID + "-" + i,
                            title: "Termin",
                            start: appointment.Appointment + "T" + startTimeStr,
                            end: appointment.Appointment + "T" + formatTime(nextTime),
                            extendedProps: {
                                AppointmentID: appointment.AppointmentID,
                                TimeStart: startTimeStr,
                            },
                            allDay: false
                        })

                        startTime = nextTime;
                    }
                }

                setSlots(slots);
                setTimeslotCache(oldCache => {
                    let newCache = [...oldCache];
                    let fcache = oldCache.find(c => {
                        return c.month == m && c.year == y;
                    });

                    if (!fcache) {
                        newCache.push({
                            month: m,
                            year: y,
                            time: Date.now(),
                            data: slots
                        });
                    } else {
                        fcache.time = Date.now();
                        fcache.data = slots;
                    }

                    return newCache;
                });

                if (json.slots.length == 0) {
                    const info = <div>Es wurden keine Termine gefunden.<a className="d-block" href='/vorfuehrtermine-kontakt'>Jetzt Termin vereinbaren!</a></div>;
                    toast.info(info, { autoClose: 10000 });
                }
            }
        }
        catch (ex) {
            setLoading(false);
            console.error(ex);
            toast.error("Laden der Termine fehlgeschlagen.");
        }
    }

    useEffect(() => {
        loadSlots();
    }, []);

    const events = useMemo(() => {
        let events = [];

        if (slots !== false) {
            events = slots.map((timeslot) => {
                return timeslot;
            });
        }

        let holidays = getHolidays(year, false);

        let d = new Date();
        for (var i = 0; i < holidays.length; i++) {
            events.push({
                start: holidays[i].date,
                allDay: true,
                display: "background",
                color: "#f2f2f2",
                title: holidays[i].name,
                extendedProps: { holiday: true }
            });
        }


        return events;
    }, [slots, year]);

    useEffect(() => {
        if (!slots) return;
        let fcache = timeslotCache.find(m => {
            return m.month == month && m.year == year;
        });

        if (fcache && fcache.time + 1000 * 60 * 15 > Date.now()) {
            if (fcache.data.length == 0) {
                toast.info("Es wurden keine Termine gefunden.", { autoClose: 10000 });
            }
            return setSlots(fcache.data);
        } else {
            console.log("cache doesn't exist or to old");
        }

        setLoading(true);
        loadSlots();
    }, [month, year]);


    if (slots === false) return <Loader />;

    return (
        <div className="position-relative">
            <CalendarHeader
                calendarRef={calendarRef}
                viewType={view}
            />
            <div style={{ menu: provided => ({ ...provided, zIndex: 200 }) }}>
                <FullCalendar ref={calendarRef}
                    selectable={true}
                    plugins={[dayGridPlugin, interactionPlugin]}
                    initialView={view}
                    //themeSystem='bootstrap'
                    weekends={true}
                    weekNumbers={true}
                    displayEventTime={true}
                    displayEventEnd={false}
                    businessHours={true}
                    firstDay='1'
                    locales={[deLocale]}
                    locale='de'
                    height='auto'
                    hiddenDays={[0]}
                    headerToolbar={false}
                    navLinks={true}
                    events={events}
                    eventTimeFormat={{
                        hour: '2-digit',
                        minute: '2-digit',
                        meridiem: false,
                        hour12: false
                    }}
                    eventClick={(info) => { setEvent(info.event); setModal(true); }}
                    views={{
                        dayGridMonth: {
                            dayMaxEvents: 6,
                        }
                    }}
                    datesSet={(info) => {
                        switch (info.view.type) {
                            case "dayGridMonth":
                                var date = new Date(info.startStr);
                                date.setDate(date.getDate() + 7);
                                var m = date.getMonth() + 1;
                                var y = date.getFullYear();
                                setMonth(m);
                                setYear(y);
                                break;
                            case "dayGridWeek":
                                var m = info.start.getMonth() + 1;
                                var y = info.start.getFullYear();
                                setMonth(m);
                                setYear(y);
                                break;
                            case "dayGridDay":
                                var m = info.start.getMonth() + 1;
                                var y = info.start.getFullYear();
                                setMonth(m);
                                setYear(y);
                                break;
                        }

                        setView(info.view.type);
                    }}
                />
            </div>
            {loading && (
                <div className="loading-wrapper-absolute">
                    <Loader />
                </div>
            )}
            <ModalForm modal={modal} setModal={setModal} event={event} updateSlots={updateSlots} />
        </div>
    );
}



const ModalForm = ({ modal, setModal, event, updateSlots }) => {
    const { Salutations } = useContext(AppContext);
    const { request } = useRequest();

    const formRef = useRef();
  
    const [message, setMessage] = useState("");
    const [disabled, setDisabled] = useState(false);

    const closeModal = () => {
        if (disabled) return;
        setModal(false);
    }

    const bookEvent = async (values) => {
        try {
            setMessage("");
            setDisabled(true);
            const data = {
                ...values, 
                AppointmentID: event.extendedProps.AppointmentID,
                Time: event.extendedProps.TimeStart,
            }
            const result = await request("/Home/BookSlot", data);
            const json = result.data;
            setDisabled(false);

            if (json.r == 1) {
                updateSlots(event);
                closeModal();

                toast.success("Buchung erfolgreich.");
            }
            else {
                setMessage(json.message);
            }
        }
        catch (ex) {
            setDisabled(false);
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    }

    useEffect(() => {
        setMessage("");
    }, [event]);

    if (!event) return null;

    var d = new Date(event.start);
    var dd = String(d.getDate()).padStart(2, '0');
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var yyyy = d.getFullYear();

    var today = dd + '.' + mm + '.' + yyyy + ", " + d.toLocaleDateString("de-DE", { weekday: 'short' });

    return (
        <Modal show={modal} onHide={closeModal}>
            <Modal.Header>
                <Modal.Title>Vorführtermin buchen</Modal.Title>
                <ModalCloseButton onClick={closeModal} />
            </Modal.Header>
            <Modal.Body>
                {message && <Alert type="error" message={message} />}
                <Row>
                    <Col sm={4}>
                        Datum
                    </Col>
                    <Col sm={8}>
                        {today}
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Zeitraum
                    </Col>
                    <Col sm={8}>
                        {formatTime(event.start)} - {formatTime(event.end)} Uhr
                    </Col>
                </Row>

                <Separator style={{ marginBottom: "0.5rem" }} text="Persönliche Daten" />

                <Formik
                    innerRef={(f) => (formRef.current = f)}
                    validationSchema={schema}
                    onSubmit={(values) => {
                        bookEvent(values);
                    }}
                    initialValues={{
                        SalutationID: '1',
                        FirstName: '',
                        LastName: '',
                        Email: '',
                        PhoneNo: '',
                        Message: '',
                        OrganisationName: ''
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        values,
                        touched,
                        isValid,
                        errors,
                    }) => {
                        return (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group as={Row} className="mb-3" controlId="SalutationID">
                                    <Form.Label column className="required" sm={6}>Anrede</Form.Label>
                                    <Col sm={6}>
                                        <Form.Select disabled={disabled} className="form-control" isInvalid={errors.SalutationID && touched.SalutationID} name="SalutationID" value={values.SalutationID} onBlur={handleBlur} onChange={handleChange}>
                                            {Salutations.map((option) => {
                                                return (
                                                    <option key={option.SalutationID} value={option.SalutationID}>
                                                        {option.Description}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.SalutationID}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="FirstName">
                                    <Form.Label column className="required" sm={6}>Vorname</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.FirstName && touched.FirstName} type="text" name="FirstName" value={values.FirstName} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.FirstName}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="LastName">
                                    <Form.Label column className="required" sm={6}>Nachname</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.LastName && touched.LastName} type="text" name="LastName" value={values.LastName} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.LastName}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="Email">
                                    <Form.Label column className="required" sm={6}>E-Mail-Adresse</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.Email && touched.Email} type="email" name="Email" value={values.Email} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Email}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="PhoneNo">
                                    <Form.Label column sm={6}>Telefonnr. (optional)</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.PhoneNo && touched.PhoneNo} type="text" name="PhoneNo" value={values.PhoneNo} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.PhoneNo}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="OrganisationName">
                                    <Form.Label column className="required" sm={6}>Organisationsname</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control disabled={disabled} isInvalid={errors.OrganisationName && touched.OrganisationName} type="text" name="OrganisationName" value={values.OrganisationName} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.OrganisationName}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="Message">
                                    <Form.Label column sm={12}>Nachricht</Form.Label>
                                    <Col sm={12}>
                                        <Form.Control disabled={disabled} as="textarea" name="Message" value={values.Message} onBlur={handleBlur} onChange={handleChange} />
                                    </Col>
                                </Form.Group>

                                <MandatoryFieldNotice/>

                                Bitte nehmen Sie auch unsere <a target="_blank" href="/datenschutz"><u>Datenschutzerklärung</u></a> zur Kenntnis.
                            </Form>
                        )
                    }}
                </Formik>
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={disabled} variant="dark" onClick={closeModal}>
                    Abbrechen
                </Button>
                <Button disabled={disabled} variant="secondary" onClick={() => { formRef.current.handleSubmit(); }}>
                    Buchen
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

export default AppointmentCalendar;